<template>
  <div class="ToIntoFail">
    <div class="TransferFailed_box">
      <CustomHead srcName="failed.png">
        <div class="TransferFailed">{{ isText || '' }}失败</div>
        <div class="TransferFailed_tip">{{ retMsg || '' }}</div>
      </CustomHead>
    </div>
    <div class="activateAccount" @click="activateAccount" v-if="false">
      激活账户
    </div>
    <FooterTwoButton
      left="返回我的融资"
      :right="flagContent"
      :leftNext="leftNext"
      :rightNext="rightNext"
    ></FooterTwoButton>
    <self-popup @define="define" v-model="ShowContent"></self-popup>

    <div class="loadingBox" v-if="IsloadingBox">
      <!-- accountFont="加载中..."  -->
      <Loading color="#fff" type="spinner"></Loading>
    </div>
  </div>
</template>
<script>
import FooterTwoButton from '@/components/FooterTwoButton.vue';
import CustomHead from '@/components/CustomHead.vue';
import Loading from '@/components/Loading.vue';

export default {
  name: 'ToIntoFail',
  data() {
    return {
      retMsg: this.$router.currentRoute.query.ret_msg || '',
      isText: this.$router.currentRoute.query.isText || '',
      activate: false,
      uuid: '',
      ShowContent: '',
      IsloadingBox: false,
      timer: null,
    };
  },
  components: {
    FooterTwoButton,
    CustomHead,
    Loading,
  },
  computed: {
    flagContent() {
      if (this.isText === '签署') {
        return '';
      };
      return `重新${this.isText}`;
    },
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      // eslint-disable-next-line camelcase
      const { retCode, ret_msg } = this.$router.currentRoute.query;
      if (retCode === 'EDC0002') {
        this.activate = true;
      }
      // eslint-disable-next-line camelcase
      this.retMsg = ret_msg;
      // eslint-disable-next-line default-case
      switch (this.isText) {
        case '转入':
          window.document.title = '转入失败';
          break;
        case '转出':
          window.document.title = '转出失败';
          break;
        case '签署':
          window.document.title = '签署失败';
          break;
      }
    },
    leftNext() {
      this.$router.push('/supermarket/v2/myload');
    },
    rightNext() {
      if (this.isText === '转入') {
        this.$router.push(
          `/supermarket/v2/EnterAmount?orderId=${this.$router.currentRoute.query.orderId}`,
        );
      } else if (this.isText === '转出') {
        this.$router.push(
          `/supermarket/v2/OutAmount?orderId=${this.$router.currentRoute.query.orderId}`,
        );
      } else if (this.isText === '签署') {
        localStorage.setItem('orderId', this.$router.currentRoute.query.orderId);
        this.$router.push('/supermarket/v2/signLoanContract');
      }
    },
    activateAccount() {
      this.IsloadingBox = true;
      this.$api.CommonForms.getActivate({
        orderId:
          this.$router.currentRoute.query.orderId
          || localStorage.getItem('orderId'),
      })
        .then(async (res) => {
          if (res.success) {
            this.uuid = res.data.uuid;
            await this.polling();
          } else {
            this.ShowContent = res.returnMessage;
            this.IsloadingBox = false;
          }
        })
        .catch((e) => {
          this.IsloadingBox = false;
          this.ShowContent = e;
        });
    },
    async polling() {
      let timer = '';
      const that = this;
      const params = {
        uuid: this.uuid,
        orderId: this.$router.currentRoute.query.orderId,
      };
      const FAILURE_STATUS = '0';
      const SUCCESS_STATUS = '1';
      const PROCESSING_STATUS = '2';
      await (function getActivateQuery() {
        that.$api.CommonForms.getActivateQuery(params)
          .then((res) => {
            if (res.success) {
              clearInterval(timer);
              if (res.data.status === FAILURE_STATUS) {
                // 失败
                clearInterval(timer);
                that.ShowContent = res.data.ret_msg;
                that.IsloadingBox = false;
              } else if (res.data.status === SUCCESS_STATUS) {
                // 成功
                clearInterval(timer);
                that.ShowContent = '激活成功';
                that.IsloadingBox = false;
              } else if (res.data.status === PROCESSING_STATUS) {
                // 银行处理中
                timer = setInterval(getActivateQuery, 3000);
                that.timer = timer;
              }
            } else {
              clearInterval(timer);
              that.IsloadingBox = false;
              that.ShowContent = res.returnMessage;
            }
          })
          .catch(() => {
            that.IsloadingBox = false;
          });
      }());
    },
    define(obj) {
      if (obj.value === '激活成功') {
        this.rightNext();
      }
      // eslint-disable-next-line no-unused-expressions
      obj.cb && obj.cb();
    },
  },
};
</script>
<style scoped>
.ToIntoFail {
  background: #fff;
}
.loadingBox {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.TransferFailed_box {
  margin-bottom: 16px;
}
.TransferFailed {
  font-family: PingFangSC-Medium;
  font-size: 17px;
  margin-top: 19px;
  color: #1c2438;
}
.TransferFailed_tip {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #9ea7b4;
  margin: 16px 0;
}
.activateAccount {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #ff6538;
  margin-bottom: 50px;
}
</style>
